// 根据不同项目初始化 GOOD_CONFIG ｜ SCIENCE_CONFIG
window.initConfig("SCIENCE_CONFIG");
